import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../auth-context.js';
import { consumeGoogleRedirect } from '../google.js';
import { sanitizeReturnTo } from '../return-to.js';

/** Public callback route for the same-tab Google authorization-code flow. */
export function GoogleRedirectCallback() {
  const { loginWithGoogleRedirect } = useAuth();
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const search = window.location.search;
    window.history.replaceState(null, '', window.location.pathname);
    void (async () => {
      try {
        const pending = consumeGoogleRedirect(search);
        await loginWithGoogleRedirect(pending.code, pending.codeVerifier, pending.nonce);
        window.location.replace(sanitizeReturnTo(pending.returnTo) ?? '/');
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Google sign-in failed. Please try again.');
      }
    })();
  }, [loginWithGoogleRedirect]);

  return (
    <main className="dsp-login-page">
      {error ? (
        <div role="alert">
          <p>{error}</p>
          <a href="/login">Back to sign in</a>
        </div>
      ) : (
        <p role="status">Completing Google sign-in…</p>
      )}
    </main>
  );
}
